import { omit } from 'ramda';

import { EActionTypes } from '../../constants/actionTypes/pickedSpecialist';
import { ISpecialistCatalogListingSchema } from '../../repositories/demand/entities/specialist_catalog/SpecialistCatalogListingSchema';
import { TReduxActions } from '../../types/redux';

export interface IPickedSpecialists {
  [key: number]: ISpecialistCatalogListingSchema;
}

export function pickedSpecialistReducer(state: IPickedSpecialists = {}, { type, payload }: TReduxActions) {
  switch (type) {
    case EActionTypes.ADD_SPECIALIST:
      return { ...state, [payload.id]: payload };

    case EActionTypes.REMOVE_SPECIALIST:
      return omit([payload], state);

    default:
      return state;
  }
}
